import { Injectable } from '@angular/core';
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { format } from 'date-fns';

import { parseToDateStruct } from './date-parser';

@Injectable()
export class UsDateParserFormatter extends NgbDateParserFormatter {
  override parse(value: string): NgbDateStruct | null {
    return parseToDateStruct(value);
  }

  override format(date: NgbDateStruct | null): string {
    if (!date) {
      return '';
    }
    // Build a JS Date for formatting
    const dt = new Date(date.year, date.month - 1, date.day);
    return format(dt, 'MM/dd/yyyy');
  }
}
